import styled from 'styled-components'

export const Wrapper = styled.div`
  padding-top: 24px;
`

export const Title = styled.div`
  color: #213f68;
  font-size: 18px;
  font-weight: 700;
`

export const Information = styled.div`
  margin-top: 24px;
  display: flex;
  gap: 8px;
  > div {
    border: 1px solid #d9d9d9;
    padding: 12px 24px;
    border-radius: 16px;
    width: 50%;
    display: flex;
    gap: 8px;
    align-items: center;
    > div {
      width: 50%;
      > span {
        font-size: 14px;
        font-weight: 700;
      }
      > div {
        font-size: 14px;
        color: #757575;
      }
    }
    > div + div {
      font-size: 14px;
      display: flex;
      gap: 4px;
      align-items: center;
      justify-content: end;
      > svg {
        background-color: #e7f3fe;
        border-radius: 4px;
        height: 16px;
        width: 16px;
        padding: 4px;
      }
      > span {
        font-size: 20px;
        font-weight: 700;
      }
    }
  }
`

export const MinimumPassingScore = styled.div`
  padding: 16px 0px;
  margin-top: 16px;
  border-bottom: 1px solid #d9d9d9;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  > div {
    > span {
      color: #363636;
      font-size: 14px;
      font-weight: 500;
    }
    > span + div {
      color: #757575;
      font-size: 14px;
      margin-top: 4px;
    }
  }
  > div + div {
    width: 230px;
    > div {
      input {
        width: 140px;
        height: 40px;
      }
      input + span {
        margin-left: 16px;
        color: #757575;
        font-size: 14px;
        font-weight: 700;
      }
    }
    > div + div {
      font-size: 12px;
      font-weight: 700;
      margin-top: 4px;
      svg {
        margin: 0 6px 0 4px;
      }
    }
  }
`

export const Alert = styled.div`
  border: 1px solid #ffeaa3;
  background: #fff9e3;
  border-radius: 8px;
  padding: 16px;
  font-size: 14px;
  color: #363636;
  margin-top: 24px;
  svg {
    color: #d48806;
    margin: 3px 3px 0px 3px;
    position: absolute;
  }
  div {
    margin-left: 27px;
  }
`
